import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 29.6rem;
  background: #fff;

  border-radius: 0.2rem;
`;

export const Header = styled.div`
  margin: 2rem 0rem 0rem 2rem;

  display: flex;
`;

export const Title = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: 600;
  font-size: 1.21rem;
  line-height: 1.5rem;
  padding-left: 0.6rem;
`;

export const Warning = styled.div`
  display: flex;
  width: 25.55rem;
  background: #cff8e7;
  border-radius: 1.88249px;

  margin: 1rem 0rem 0rem 2rem;
  align-items: center;

  svg {
    margin: 0.875rem 0rem 0.875rem 0.6rem;
    width: 2rem;
    height: 2rem;
  }
`;

export const WarningText = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: normal;
  font-size: 0.74rem;
  line-height: 1.07rem;

  color: #118052;

  margin: 0.47rem 0rem 0.47rem 0.6rem;
`;

export const Body = styled.div`
  width: 25.55rem;
  height: 15rem;
  margin: 2rem 0rem 0rem 2rem;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Footer = styled.div`
  width: 25.145rem;
  height: 2.815rem;
  margin: 2rem 2.22rem;

  display: flex;
  justify-content: space-between;
`;

export const DivIcon = styled.div`
  position: absolute;
  top: 1.125rem;
  right: 0.9375rem;
  cursor: pointer;

  svg {
    width: 0.75rem;
    height: 0.75rem;
    &:hover {
      path,
      rect {
        stroke: #40e5a0;
      }
    }
  }
`;

export const Checkers = styled.span`
  color: ${(props) => (props.check ? "#7e858f" : "#ea6868")};
  font-size: 0.7rem;
  line-height: 0.8333rem;
  padding: 0.5rem 0rem 0rem 0rem;
`;
